import React from 'react'
import ToolsTabs from './ToolsTabs'

const Tools = ({ user, fieldOverrides }) => {
  return <ToolsTabs user={user} fieldOverrides={fieldOverrides} />
}

export default Tools
